<div ngbAccordion #cashSubAccordion="ngbAccordion">
  <!-- Earnings -->
  <div
    ngbAccordionItem
    ngbAccordionItem="earningAccordion"
    #earningAccordion="ngbAccordionItem"
    [collapsed]="true">
    <div class="row w-100 fw-bold border-bottom accordion-header">
      <div class="col-auto ms-1 p-0">
        <button
          (click)="cashSubAccordion.toggle('earningAccordion')"
          class="btn btn-link btn-sm p-0"
          title="Earnings">
          <span
            [className]="
              !earningAccordion.collapsed ? 'collapse-icon open me-0' : 'collapse-icon me-0'
            "></span>
        </button>
      </div>
      <div class="col-4 col-lg-6 col-xl-8 ms-0">Earnings</div>
      <div class="text-end col">Hours</div>
      <div class="text-end col">{{ payrollSummary.Earnings.Hours | number: '1.2-2' }}</div>
      <div class="text-end col">Gross</div>
      <div class="text-end col">{{ payrollSummary.Earnings.Gross | currency }}</div>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="px-0">
        <ng-template>
          <div *ngFor="let earnName of orderedLists.EarningsNames" class="row w-100">
            <div class="col-4 col-lg-6 col-xl-8 ms-4">{{ earnName }}</div>
            <div class="col text-end"></div>
            <div class="text-end col">
              {{ payrollSummary.Earnings.Totals[earnName].TotalHours | number: '1.2-2' }}
            </div>
            <div class="text-end col"></div>
            <div class="text-end col">
              {{ payrollSummary.Earnings.Totals[earnName].TotalAmount | currency }}
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Taxes -->
  <div
    ngbAccordionItem
    ngbAccordionItem="taxAccordion"
    #taxAccordion="ngbAccordionItem"
    [collapsed]="true">
    <div class="row w-100 fw-bold border-bottom accordion-header">
      <div class="col-auto ms-1 p-0">
        <button
          (click)="cashSubAccordion.toggle('taxAccordion')"
          class="btn btn-link btn-sm p-0"
          title="Taxes">
          <span
            [className]="
              !taxAccordion.collapsed ? 'collapse-icon open me-0' : 'collapse-icon me-0'
            "></span>
        </button>
      </div>
      <div class="col">Taxes</div>
      <div class="col-3 text-end">
        {{ payrollSummary.Tax.Total | currency }}
      </div>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="px-0">
        <ng-template>
          <div *ngIf="payrollSummary.Tax.Employer" class="row w-100 fw-bold">
            <div class="col ms-4">Employer Taxes</div>
            <div class="col-3 text-end">{{ payrollSummary.Tax.Employer | currency }}</div>
          </div>
          <div *ngFor="let employerTax of orderedLists.EmployerTaxes" class="row w-100">
            <div class="col ms-4">
              {{ employerTax.TaxCode }}
            </div>
            <div class="col-3 text-end">
              {{ employerTax.Amount | number: '1.2-2' }}
            </div>
          </div>

          <div *ngIf="payrollSummary.Tax.Employee" class="row w-100 fw-bold">
            <div class="col ms-4">Employee Taxes</div>
            <div class="col-3 text-end">{{ payrollSummary.Tax.Employee | currency }}</div>
          </div>
          <div *ngFor="let employeeTax of orderedLists.EmployeeTaxes" class="row w-100">
            <div class="col ms-4">
              {{ employeeTax.TaxCode }}
            </div>
            <div class="col-3 text-end">
              {{ employeeTax.Amount | number: '1.2-2' }}
            </div>
          </div>

          <ng-container *ngIf="!payrollSummary.Tax.Employee && !payrollSummary.Tax.Employer">
            <div class="row">
              <div class="col-12 ms-4" class="fst-italic">No tax records to display</div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Deductions -->
  <div
    ngbAccordionItem
    ngbAccordionItem="dedAccordion"
    #dedAccordion="ngbAccordionItem"
    [collapsed]="true">
    <div class="row w-100 fw-bold border-bottom accordion-header">
      <div class="col-auto ms-1 p-0">
        <button
          (click)="cashSubAccordion.toggle('dedAccordion')"
          class="btn btn-link btn-sm p-0"
          title="Deductions">
          <span
            [className]="
              !dedAccordion.collapsed ? 'collapse-icon open me-0' : 'collapse-icon me-0'
            "></span>
        </button>
      </div>
      <div class="col">Deductions</div>
      <div class="col-3 text-end">
        {{ payrollSummary.Deductions.DeductionsTotal | currency }}
      </div>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="px-0">
        <ng-template>
          <div *ngIf="payrollSummary.Deductions.DeductionsEmployeeTotal" class="row w-100 fw-bold">
            <div class="col ms-4">Employee Deductions</div>
            <div class="col-3 text-end">
              {{ payrollSummary.Deductions.DeductionsEmployeeTotal | currency }}
            </div>
          </div>
          <div *ngFor="let dedName of orderedLists.EmployeeDeductionNames" class="row w-100">
            <td></td>
            <div class="col ms-4">{{ dedName }}</div>
            <div class="col-3 text-end">
              {{ payrollSummary.Deductions.EmployeeDeductionTotals[dedName] | number: '1.2-2' }}
            </div>
          </div>

          <div *ngIf="payrollSummary.Deductions.DeductionsMemoTotal" class="row w-100 fw-bold">
            <div class="col ms-4">Employer Deductions</div>
            <div class="col-3 text-end">
              {{ payrollSummary.Deductions.DeductionsMemoTotal | currency }}
            </div>
          </div>
          <div *ngFor="let dedName of orderedLists.MemoDeductionNames" class="row w-100">
            <td></td>
            <div class="col ms-4">{{ dedName }}</div>
            <div class="col-3 text-end">
              {{ payrollSummary.Deductions.MemoItemDeductionTotals[dedName] | number: '1.2-2' }}
            </div>
          </div>

          <ng-container
            *ngIf="
              !payrollSummary.Deductions.DeductionsEmployeeTotal &&
              !payrollSummary.Deductions.DeductionsMemoTotal
            ">
            <div class="row">
              <div class="col-12 ms-4">No deduction records to display</div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Paylines -->
  <div
    ngbAccordionItem
    ngbAccordionItem="paylineAccordion"
    #paylineAccordion="ngbAccordionItem"
    [collapsed]="true">
    <div class="row w-100 fw-bold border-bottom accordion-header">
      <div class="col-auto ms-1 p-0">
        <button
          (click)="cashSubAccordion.toggle('paylineAccordion')"
          class="btn btn-link btn-sm p-0"
          title="Paylines">
          <span
            [className]="
              !paylineAccordion.collapsed ? 'collapse-icon open me-0' : 'collapse-icon me-0'
            "></span>
        </button>
      </div>
      <div class="col-4 col-lg-6 col-xl-8">Paylines/Net</div>
      <div class="col text-end">Paylines</div>
      <div class="col text-end">{{ payrollSummary.Totals.PaylineCount }}</div>
      <div class="col text-end">Net</div>
      <div class="col text-end">{{ payrollSummary.Totals.Net | currency }}</div>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="px-0">
        <ng-template>
          <div *ngIf="payrollSummary.Totals.DirectDeposits" class="row w-100">
            <div class="col ms-4">Direct Deposit</div>
            <div class="col text-end">
              {{ math.max(payrollSummary.Totals.DirectDeposits, 0) | currency }}
            </div>
          </div>
          <div *ngIf="payrollSummary.Totals.NetChecks" class="row w-100">
            <div class="col ms-4">Net Checks</div>
            <div class="col text-end">{{ payrollSummary.Totals.NetChecks | currency }}</div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
